<template>
  <div class="home">
   
      <div class="meetingName">{{meeting.name}}</div>
      <div class="Pc-meetingName">
            <div class="logo">
              <img :src="`${showImgUrl}${meeting.logo}`||require('../assets/logo.png')" alt="">
            </div>
            <div class="now" @click="jump({id:'now', route: '/choose_tickets'})">立刻报名</div>
            <div class="reserve" v-if="meeting.hotelStatus==1" @click="jump({id:'hotel', route: '/hotel_list'})">住宿预定</div>
            <div class="my" @click="jump({id:'mine', route: '/profile'})">个人中心</div>
      </div>
      <img v-if="isPc" class="banner" :src="`${showImgUrl}${meeting.banner}`" alt />
      <img v-else class="banner" :src="`${showImgUrl}${meeting.appBanner}`" alt="">
      <div class="homePC">
        <div class="des-title">大会简介</div>
        <div class="des-content">{{meeting.remark}}</div>
        <div class="time">
          <p class="title">时间/地点</p>
          <p>开始时间：{{meeting.startTime}}</p>
          <p>结束时间：{{meeting.endTime}}</p>
          <p>{{meeting.province}} · {{meeting.city}} · {{meeting.address}}</p>
        </div>
      </div>
      <div class="pc-time">
        <p class="title">时间/地点</p>
        <p class="one">开始时间：{{meeting.startTime}}</p>
        <p class="one">结束时间：{{meeting.endTime}}</p>
        <p class="two">{{meeting.province}} · {{meeting.city}} · {{meeting.address}}</p>
       
      </div>
      <div class="des-title">会议日程</div>
      <div class="ScheduleList">
        <img v-for="(item, index) in meetingScheduleList" :src="`${showImgUrl}${item.img}`" :key="index" alt />
      </div>
      <div class="footer">
        <div
          v-for="item in tabs"
          :key="item.id"
          :class="`${item.id} ${active===item.id&&'active'}`"
          @click="jump(item)"
        >{{item.name}}</div>
      </div>
      <!-- <div class="pc-time pc-time2">
        <p class="title">缴费信息</p>          
        <p class="two"> 收款账号：123456789135135468 </p>
        <p class="two">汇款名称：北京佰瑞时代会展有限公司</p>
        <p class="two">开户行：民生银行</p>
        <p class="two">备注：张晶超住宿费</p>
      </div>
      <div class="pc-time3">
        <p class="title">会务联系人</p>          
        <p class="two"> 张晶超 13436979719</p>
        <p class="two"> 张斯琳 12345678910</p>
      </div> -->
      <div class="pc-time4"></div>
    

    <!-- 弹窗 -->
    <el-dialog title="个人中心" center :visible.sync="dialogVisible" style="margin-top:0vw;">
      <!-- 表单 -->
      <el-form
        ref="profileForm"
        :model="profileForm"
        :rules="profileRules"
        size="medium"
        class="profileForm"
      >
        <el-form-item prop="phone">
          <el-col :span="5" class="content-item">手机号：</el-col>
          <el-col :span="15">
            <el-input v-model="profileForm.phone" class="content-item"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item prop="verify" >
          <el-col :span="5" class="content-item">验证码</el-col>
          <el-col :span="10">
            <el-input v-model="profileForm.verify" class="content-item"></el-input>
          </el-col>
          <el-col :span="8">
            <el-button v-if="issend" style="font-size: 12px" type="default" size="small" :class="{disabled:issend}" @click="sendCode">
              {{num}}秒后重新发送
            </el-button>
            <el-button v-else :class="{disabled:issend}" style="font-size: 12px;" size="small" @click="sendCode">
                获取验证码
            </el-button>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-col :span="24" style="text-align:center">
            <el-button type="primary" size="large" @click="getUserinfo" style="font-size: 12px">登录</el-button>
          </el-col>
        </el-form-item>
      </el-form>

    </el-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import http from '../utils/http'
import apis from '../utils/apis'
export default {
  name: 'home',
  components: {
  },
  data() {
    return {
      num: 59,
      issend: false,
      profileForm: {
        phone: '',
        verify: ''
      },
      profileRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { min: 11, max: 11, message: '手机号必须11位数字', trigger: 'blur' }
        ],
        verify: [
          { required: true, message: '请选择验证码', trigger: 'blur' }
        ],
      },
      dialogVisible: false,
      meeting: {},
      meetingScheduleList: {},
      tabs: [
        {
          name: '个人中心',
          id: 'mine',
          route: '/profile'
        },
        {
          name: '立刻报名',
          id: 'register',
          route: '/choose_tickets'
        },
      ],
      active: 'register',
      showImgUrl: process.env.VUE_APP_SHOW_IMGURL,
      meetingTicketList: null
    }
  },
  methods: {
    async getMeetingInfo() {
      const res = await http.get(`${apis.getMeetingInfo}/${this.meetingId}`)
      console.log(res)
      this.meeting = res.result.meeting
      this.meetingScheduleList = res.result.meetingScheduleList
      this.meetingTicketList = res.result.meetingTicketList
      document.title=this.meeting.name
      localStorage.setItem('meeting',JSON.stringify(this.meeting))
    },
    jump(item) {
      this.active = item.id
      if (item.id === 'mine') {
        const audienceId = localStorage.getItem('audienceId')
        const audienceIdAndMeetingId = localStorage.getItem('audienceIdAndMeetingId')
        if(!localStorage.getItem('audienceId') ){
            this.dialogVisible = true;//弹窗
            return
        }else{
            if(audienceIdAndMeetingId ){
                if(JSON.parse(audienceIdAndMeetingId).meetingId !== this.meetingId){
                    this.dialogVisible = true;//弹窗
                    return
                }
            }else{
                this.dialogVisible = true;//弹窗
                return
            }
        }
      }
      if(item.id === 'hotel') {
          console.log('2222')
          const audienceId = localStorage.getItem('audienceId')
          const audienceIdAndMeetingId = localStorage.getItem('audienceIdAndMeetingId')
          if(!localStorage.getItem('audienceId') ){
            this.$alert('请先报名，如已报名请先登录个人中心', '',{
                    showClose: false
              })
              return
          }else{
              if(audienceIdAndMeetingId ){
                  if(JSON.parse(audienceIdAndMeetingId).meetingId !== this.meetingId){
                      this.$alert('请先报名，如已报名请先登录个人中心', '',{
                          showClose: false
                      })
                      return
                  }
              }else{
                  this.$alert('请先报名，如已报名请先登录个人中心', '',{
                      showClose: false
                  })
                  return
              }
          }
          if(!localStorage.getItem('audienceId') || (audienceId && audienceIdAndMeetingId && JSON.parse(audienceIdAndMeetingId).meetingId !== this.meetingId) ){
              this.$alert('请先报名，如已报名请先登录个人中心', '',{
                    showClose: false
              })
              return
          }
      }
      // if(item.id==='register'&&this.meetingTicketList && this.meetingTicketList.length<=0){
      //     let str=JSON.stringify({"id":0,"meetingId":0,"ticketName":"","chargeType":1,"sellCount":10000,"sellStartTime":"2020-09-19 00:00:00","sellEndTime":"2020-09-20 00:00:00","maxAmount":1,"ticketDesc":"用于测试","price":100,"discounDate":null,"discounMoney":0,"createUserId":null,"createTime":"2020-09-19 21:38:20","updateTime":"2020-09-19 21:38:20","isover":true})
      //     localStorage.setItem('ticket',str)
      //     this.$router.push('/register')
      //     return
      // }
      this.$router.push(item.route)
    },
    async sendCode() {
      if (this.issend) {
        return false;
      }

      let phoneReg = /^(13[0-9]|15[0-35-9]|166|17[0-37]|18[0-35-9])\d{8}$/; // 11位的阿拉伯数字 13 15 166 170 18
      if (phoneReg.test(this.profileForm.phone) == false) {
        this.$message.error('手机号码不合法')
        return false; // 阻止请求的发送
      }

      
      
      let params = {
        mobile: this.profileForm.phone,
        meetingId: this.meetingId
      }
      const res = await http.get(`${apis.sendCode}`, {
        params
      }).catch(err => err)
      console.log(res)
      if (res.code === 0) {
          this.$message.success('验证码已经发送到手机');
          this.issend = true
      // 1.7 实现倒计时的功能
          this.num = 59;
      //  console.log('this.num',this.num-1)
          let timeId = setInterval(() => {
            this.num = this.num - 1
            console.log('this.num', this.num)
            if (this.num <= 0) {
              clearInterval(timeId)
              // 移除原来添加的disabled,不要再有灰色了,而且 按钮内容要恢复原状
              // $('.verify').removeClass('disabled').val('获取验证码')
              this.num = 59
              this.issend = false
            }
          }, 1000);
      }else{
          this.$alert('您尚未报名，请先进行报名', '',{
              showClose: false,
              callback: (action) => {
                  if(action==='confirm') {
                      this.$router.push('/choose_tickets')
                  }
              }
          })
      }
      

    },
    async getUserPhone() {
      // this.$store.commit('SET_CURRENT_HOTEL', item)
      const params = {
          mobile: this.profileForm.phone
      }
      const res = await http.get(`${apis.getUserinfo}/${this.meetingId}`, { params })
      if(res.code===0){
          alert
      }
      if(!res.audience){
          this.$alert('您还没有报名，请先报名', '',{
              showClose: false
          })
          return
      }

    },
    getUserinfo() {
      // this.$store.commit('SET_CURRENT_HOTEL', item)
      this.$refs['profileForm'].validate(async (valid) => {
        if (valid) {
          let params = {
            code: this.profileForm.verify,
            mobile: this.profileForm.phone
          }
          // const res = await http.get(`${apis.getUserinfo}/${this.meetingId}`,{params})
          const res = await http.get(`${apis.getUserinfo}/${this.meetingId}`, { params })
          console.log('个人信息', res)
          if (res.code === 0) {
            if(!res.audience){
                this.$alert('您还没有报名，请先报名', '',{
                    showClose: false
                  })
                return
            }
            this.$store.commit('SET_USERINFO', res.audience)
            localStorage.setItem('userinfo', JSON.stringify(res.audience))
            const audienceIdAndMeetingId = {meetingId: this.meetingId,audienceId: res.audience.id}
            localStorage.setItem('audienceId', res.audience.id)
            localStorage.setItem('audienceIdAndMeetingId',JSON.stringify(audienceIdAndMeetingId))
            this.$router.push(`/profile`)
          }else{
              this.$alert(res.msg, '',{
                    showClose: false
                  })
          }

        }
      })

    }
  },
  computed: {
    meetingId() {
      return this.$store.state.meetingId || localStorage.getItem('meetingId')
    },
    isPc() {
      return this.$store.state.isPc
    }
  },
  created() {
    let meeting=JSON.parse(localStorage.getItem('meeting'))
    if(meeting.hotelStatus==1){
        this.tabs=[
          {
            name: '个人中心',
            id: 'mine',
            route: '/profile'
          },
          {
            name: '住宿预订',
            id: 'hotel',
            route: '/hotel_list'
          },
          {
            name: '立刻报名',
            id: 'register',
            route: '/choose_tickets'
          },
        ]
    }
    
    this.getMeetingInfo()
  }
}
</script>
<style lang="stylus" scoped>
*{
  box-sizing border-box
}
.home {
  min-height: 100vh;
  background: #fff;
  padding-bottom: 100px;
}

.profileForm {
  /deep/ .el-form-item--medium .el-form-item__content, /deep/ .el-form-item--medium .el-form-item__label {
    line-height: 75px;
  }

  /deep/ .el-input__inner {
    height: 75px;
  }

  /deep/ .el-button--default {
    height: 75px;
    margin-left: 10px;
  }

  /deep/ .el-button--default.disabled {
    background-color: #CCC !important;
  }

  /deep/ .el-form-item {
    padding: 10px 7px;
  }

  /deep/ .el-form-item__error {
    margin-top: 5px;
    left: 140px;
  }

  /deep/ .el-button--large {
    padding:20px 28px;
  }
}

.meetingName {
  height: 100px;
  line-height: 100px;
  font-size: 34px;
  color: #333;
  text-align: center;
}

.banner {
  width: 100%;
}

.des-title {
  font-size: 38px;
  color: #333333;
  margin-top: 47px;
  margin-bottom: 34px;
  text-align: center;
  font-weight: 700;
}

.des-content {
  padding: 0 30px;
  font-size: 27px;
  line-height: 1.3em;
  text-align: justify;
  text-indent: 2em;
  padding-bottom: 64px;
  border-bottom: 1px solid #8F8F8F;
}

.time {
  text-align: center;
  color: #333;
  padding: 64px 30px;
  border-bottom: 1px solid #8F8F8F;

  .title {
    font-size: 38px;
    font-weight: 700;
    padding-bottom: 64px 0 36px;
  }

  p {
    font-size: 29px;
  }
}
.Pc-meetingName,.pc-time,.pc-time3,.pc-time4,pc-time2 {
    display none
}

.ScheduleList {
  padding: 30px;
  img {
    width: 100%;
  }
}

.footer {
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 80px;
  font-size: 30px;
  line-height: 80px;
  color: #2C2C2C;
  background: #D5D5D5;
  text-align: center;

  .mine {
   flex 1
  }

  .hotel {
    width: 188px;
    height: 80px;
  }

  .register {
    flex: 1;
    height: 80px;
  }

  .active {
    background: #2852A6;
    color: #ffffff;
  }
}
/deep/ .el-dialog{
  width: 620px
}
/deep/ .el-dialog__title {
    font-size: 30px;
}
.content-item{
    font-size: 24px;
}
/deep/ .el-form-item__error{
    font-size: 24px;
}
/deep/ .el-dialog__headerbtn{
    font-size: 24px;
}
@media screen and (min-width: 800px) {
  .home {
    padding-bottom 0
    .homePC{
      width 1200px
      margin 0 auto
    }
    .meetingName {
      display none
     
    }
    .Pc-meetingName{
      position relative
      height: 130px;
      width 1200px
      margin 0 auto
      background-color #fff
      overflow hidden
      .logo{
        width 240px
        // height 100px
        // background-color blue
        position absolute
        top 26px
        left 0
        img {
          width 100%
          height 100%
        }
      }
      .now {
        position absolute
        top 30px
        left 770px
        width: 120px;
        height: 40px;
        background: #2852A6;
        border-radius: 10px;
        text-align center
        line-height 40px
        font-size 22px
        color #fff
      }
      .reserve {
        position absolute
        top 30px
        left 900px
        width: 120px;
        height: 40px;
        background: #2852A6;
        border-radius: 10px;
        text-align center
        line-height 40px
        font-size 22px
        color #fff
      }
      .my {
        position absolute
        top 30px
        left 1030px
        width: 120px;
        height: 40px;
        text-align center
        line-height 40px
        background: #FFFFFF;
        border: 1px solid #282828;
        border-radius: 10px;
        font-size 22px
      }
    }

    .banner {
        width: 100%
    }

    .des-title {
      // font-size: 38px;
      // color: #333333;
      // margin-top: 47px;
      // margin-bottom: 34px;
      // text-align: center;
      // font-weight: 700;

      text-align:center
      font-size: 36px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #343434;
      margin 70px 0 36px

    }

    .des-content {
      padding: 60px 0 60px 0;
      text-indent: 2em;
      border-bottom: 0;
      font-size: 22px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #343434;
      line-height: 38px;


    }

    .time {
      display  none
    }
    .Pc-meetingName,.pc-time,.pc-time3,.pc-time4,pc-time2 {
        display block
    }
    .pc-time {
        height 236px
        border-top 1px solid #b5b5b5
        border-bottom 1px solid #b5b5b5
        background-color #f1f1f1
        text-align center
        .title {
          font-size: 36px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #343434;
          margin-top 30px
        }
        .one,.two {
          font-size: 22px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #343434;
        }
        .one{
          margin-top 10px
          margin-bottom 10px
        }
    }

    .pc-time2{
      height 340px
      .title{
        margin-top 75px
        margin-bottom 36px
      }
      .two {
        margin-bottom 2px
      }
    }

    .pc-time3 {
      overflow hidden
      height 260px
      background-color #fff
      text-align center
      .title {
        font-size: 36px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #343434;
        margin-top 60px
        margin-bottom 36px
      }
      .two {
        
        font-size: 22px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #343434;
      }
    }
    .pc-time4{
      height 145px
      background-color #373737
    }

    .ScheduleList {
      padding: 0px;
      width: 1200px;
      margin: 0 auto;
      img {
        width: 100%;
      }
    }

    .footer {
      display none
    }
  }
  .profileForm {
  /deep/ .el-form-item--medium .el-form-item__content, /deep/ .el-form-item--medium .el-form-item__label {
    line-height: 40px;
  }

  /deep/ .el-input__inner {
    height: 40px;
  }

  /deep/ .el-button--default {
    height: 40px;
    margin-left: 10px;
    margin-top:5px;
    line-height: 5px
  }

  /deep/ .el-button--default.disabled {
    background-color: #CCC !important;
  }

  /deep/ .el-form-item {
    padding: 10px 7px;
  }

  /deep/ .el-form-item__error {
    margin-top: 5px;
    left: 140px;
  }

  /deep/ .el-button--large {
    padding:20px 28px;
  }
}
  /deep/ .el-dialog{
    width: 600px
  }
  /deep/ .el-dialog__title {
    font-size: 24px;
  }
  .content-item{
      font-size: 12px;
  }
  /deep/ .el-form-item__error{
      font-size: 12px;
  }
  /deep/ .el-dialog__headerbtn{
      font-size: 12px;
  }
  .profileForm .el-input__inner {
      height: 40px;
  }
}
</style>
